// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.echanges-list {
  /* background: #FFFDFC; */
  /* border-radius: 8px; */
  padding: 2rem;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 2rem; */
}

.echanges-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  /* margin: 2rem 0; */
}

.echange-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 80%;
}

/* Message from current user aligned to right */
.echange-wrapper:has(.message-user) {
  margin-left: auto;
  align-items: flex-end;
}

/* Other messages aligned to left */
.echange-wrapper:has(.message-other),
.echange-wrapper:has(.message-platform) {
  margin-right: auto;
  align-items: flex-start;
}

.message-bubble {
  padding: 1.5rem;
  border-radius: 8px;
}

/* Message de l'utilisateur actuel */
.message-bubble.message-user {
  margin-left: auto; /* Aligne à droite */
  background-color: rgba(218, 112, 39, 0.2); /* Orange très clair */
}

/* Message de la plateforme */
.message-bubble.message-platform {
  margin-right: auto; /* Aligne à gauche */
  background-color: rgba(215, 217, 217, 0.25); /* Gris clair */
}

/* Message des autres utilisateurs */
.message-bubble.message-other {
  margin-right: auto; /* Aligne à gauche */
  background-color: rgba(4, 134, 255, 0.2); /* Bleu très clair */
}

.echange-message {
  color: #2c3948;
  font-size: 1.6rem;
  line-height: 1.5;
  margin: 0;
}

.echange-footer {
  padding: 0 1rem;
  color: #6b7280;
  font-size: 1.4rem;
}

.echange-auteur {
  font-weight: 600;
}

.echange-date {
  color: #9ca3af;
}

.echanges-title {
  margin-bottom: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/EchangesList/EchangesList.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb;qBACmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,iBAAiB,EAAE,oBAAoB;EACvC,yCAAyC,EAAE,sBAAsB;AACnE;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB,EAAE,oBAAoB;EACxC,2CAA2C,EAAE,eAAe;AAC9D;;AAEA,oCAAoC;AACpC;EACE,kBAAkB,EAAE,oBAAoB;EACxC,wCAAwC,EAAE,oBAAoB;AAChE;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".echanges-list {\r\n  /* background: #FFFDFC; */\r\n  /* border-radius: 8px; */\r\n  padding: 2rem;\r\n  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  margin-top: 2rem; */\r\n}\r\n\r\n.echanges-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  /* margin: 2rem 0; */\r\n}\r\n\r\n.echange-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  max-width: 80%;\r\n}\r\n\r\n/* Message from current user aligned to right */\r\n.echange-wrapper:has(.message-user) {\r\n  margin-left: auto;\r\n  align-items: flex-end;\r\n}\r\n\r\n/* Other messages aligned to left */\r\n.echange-wrapper:has(.message-other),\r\n.echange-wrapper:has(.message-platform) {\r\n  margin-right: auto;\r\n  align-items: flex-start;\r\n}\r\n\r\n.message-bubble {\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Message de l'utilisateur actuel */\r\n.message-bubble.message-user {\r\n  margin-left: auto; /* Aligne à droite */\r\n  background-color: rgba(218, 112, 39, 0.2); /* Orange très clair */\r\n}\r\n\r\n/* Message de la plateforme */\r\n.message-bubble.message-platform {\r\n  margin-right: auto; /* Aligne à gauche */\r\n  background-color: rgba(215, 217, 217, 0.25); /* Gris clair */\r\n}\r\n\r\n/* Message des autres utilisateurs */\r\n.message-bubble.message-other {\r\n  margin-right: auto; /* Aligne à gauche */\r\n  background-color: rgba(4, 134, 255, 0.2); /* Bleu très clair */\r\n}\r\n\r\n.echange-message {\r\n  color: #2c3948;\r\n  font-size: 1.6rem;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.echange-footer {\r\n  padding: 0 1rem;\r\n  color: #6b7280;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.echange-auteur {\r\n  font-weight: 600;\r\n}\r\n\r\n.echange-date {\r\n  color: #9ca3af;\r\n}\r\n\r\n.echanges-title {\r\n  margin-bottom: 2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
